import { Brain, Cloud, Globe, Sparkles } from "lucide-react";

export const providers = [
  {
    id: "aws_bedrock",
    name: "AWS Bedrock",
    description: "Amazon Bedrock foundation models",
    icon: Cloud,
    color: "bg-orange-100 text-orange-600",
    models: [
      {
        id: "anthropic.claude-3-sonnet-20240229-v1:0",
        name: "Claude 3 Sonnet",
        cost: "High Performance",
      },
      {
        id: "anthropic.claude-3-haiku-20240307-v1:0",
        name: "Claude 3 Haiku",
        cost: "Cost Effective",
      },
      { id: "meta.llama2-70b-chat-v1", name: "Llama 2 70B", cost: "Balanced" },
      { id: "amazon.titan-text-express-v1", name: "Amazon Titan Text", cost: "Budget Friendly" },
    ],
    fields: ["api_key", "region"],
  },
  {
    id: "gcp_vertex",
    name: "Google Cloud Vertex AI",
    description: "Google Cloud Vertex AI models",
    icon: Globe,
    color: "bg-blue-100 text-blue-600",
    models: [
      { id: "gemini-pro", name: "Gemini Pro", cost: "Moderate" },
      { id: "text-bison-001", name: "PaLM Text Bison", cost: "Cost Effective" },
      { id: "chat-bison-001", name: "PaLM Chat Bison", cost: "Conversational" },
    ],
    fields: ["api_key", "project_id", "region"],
  },
  {
    id: "azure_openai",
    name: "Azure OpenAI",
    description: "Microsoft Azure OpenAI Service",
    icon: Cloud,
    color: "bg-blue-100 text-blue-800",
    models: [
      { id: "gpt-4", name: "GPT-4", cost: "Premium" },
      { id: "gpt-35-turbo", name: "GPT-3.5 Turbo", cost: "Standard" },
      { id: "gpt-35-turbo-16k", name: "GPT-3.5 Turbo 16K", cost: "Extended Context" },
    ],
    fields: ["api_key", "endpoint_url", "resource_group"],
  },
  {
    id: "anthropic",
    name: "Anthropic",
    description: "Anthropic Claude API",
    icon: Brain,
    color: "bg-purple-100 text-purple-600",
    models: [
      { id: "claude-3-opus", name: "Claude 3 Opus", cost: "Premium" },
      { id: "claude-3-sonnet", name: "Claude 3 Sonnet", cost: "Balanced" },
      { id: "claude-3-haiku", name: "Claude 3 Haiku", cost: "Fast" },
    ],
    fields: ["api_key"],
  },
  {
    id: "cohere",
    name: "Cohere",
    description: "Cohere language models",
    icon: Sparkles,
    color: "bg-green-100 text-green-600",
    models: [
      { id: "command", name: "Command", cost: "Standard" },
      { id: "command-light", name: "Command Light", cost: "Lightweight" },
    ],
    fields: ["api_key"],
  },
  {
    id: "huggingface",
    name: "Hugging Face",
    description: "Hugging Face Inference API",
    icon: Globe,
    color: "bg-yellow-100 text-yellow-600",
    models: [
      { id: "mistralai/Mixtral-8x7B-Instruct-v0.1", name: "Mixtral 8x7B", cost: "Open Source" },
      { id: "microsoft/DialoGPT-large", name: "DialoGPT Large", cost: "Conversational" },
    ],
    fields: ["api_key"],
  },
];
